



























import { Component, Prop } from 'vue-property-decorator';
import FieldWrapper from '@shared/components/forms/inputs/field-wrapper/field-wrapper.vue';
import { mixins } from 'vue-class-component';
import AbstractField from '@shared/components/forms/inputs/abstract-field/abstract-field';

@Component({
  name: 'bpc-multiplayer-booking-deep-link',
  components: {
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class MultiplayerBookingDeepLink extends mixins(AbstractField) {
  @Prop([String, Number]) readonly value: string;

  copyStatus: 'none' | 'copied' | 'error' = 'none';

  async onCopyClicked() {
    try {
      await navigator.clipboard.writeText(this.value.toString());
      this.copyStatus = 'copied';
      setTimeout(() => {
        this.copyStatus = 'none';
      }, 3000);
    } catch ($e) {
      this.copyStatus = 'error';
      setTimeout(() => {
        this.copyStatus = 'none';
      }, 3000);
    }
  }
}
